import { Component, OnInit } from '@angular/core';
import { ContactEditComponent } from '../contact-edit/contact-edit.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectRole } from '../../../store/profile/profile.state';
import { RoleEnum } from '../../../enum/role.enum';
import { MatDialog } from '@angular/material/dialog';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatFabButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-create-contact-button',
    templateUrl: './create-contact-button.component.html',
    styleUrls: ['./create-contact-button.component.scss'],
    imports: [MatFabButton, IconComponent, AsyncPipe]
})
export class CreateContactButtonComponent implements OnInit {

    constructor(private dialog: MatDialog, private store: Store<AppState>) {
    }

    public editContacts$ = this.store.select(selectRole(RoleEnum.EDIT_CONTACTS));

    ngOnInit(): void {
    }

    click(): void {
        this.dialog.open(ContactEditComponent);
    }

}
